import {useState, useEffect} from 'react';
import TableStatistics from '@/shared/components/Table/TableStatistics';
import {AUCTION_REMAINING, CANCEL, ITEM_WITHOUT_BIDS, NOTIFY_WINNERS, NOTIFY} from '@/utils/constants';
import {ReactComponent as JudgeIcon} from '@icons/statistics/statistics-items.svg';
import {ReactComponent as TimeIcon} from '@icons/statistics/statistics-time.svg';
import {ReactComponent as GuestIcon} from '@icons/statistics/statistics-guests.svg';
import {ReactComponent as NotifyIcon} from '@icons/message-notif.svg';
import {Box, useMediaQuery} from '@mui/material';
import {AuctionInfoStyles} from './AuctionInfoStyles';
import {useAppSelector} from '@/store/hooks';
import {getCurrentEventSelector} from '@/store/organization-event';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import {OrganizationAuctionService} from '@/utils/services';
import Modal from '@/shared/components/Modal';
import {CommunicationService} from '@/utils/services/organization-communication.services';
import {toast} from 'react-toastify';
import {getErrorMessage} from '@/utils/helpers';
import {WinnerTableStyle} from '../WinnerTable/WinnerTableStyle.styles';
import {getAuctionWonListSelector} from '@/store/organization-auction';

dayjs.extend(duration);

const AuctionInfo = () => {
	const currentEvent = useAppSelector(getCurrentEventSelector);
	const auctionWonList = useAppSelector(getAuctionWonListSelector);

	const [timeLeft, setTimeLeft] = useState<string>('00:00:00');
	const [unBidedItems, setUnBidedItems] = useState<number>(0);
	const [isNotifyModalOpen, setIsNotifyModalOpen] = useState(false);

	const isDesktop = useMediaQuery('(min-width:1200px)');

	const handleNotifyModal = () => setIsNotifyModalOpen(!isNotifyModalOpen);

	useEffect(() => {
		if (!currentEvent?.endAuctionData) return;

		const timer = setInterval(() => {
			const now = dayjs();
			const end = dayjs(currentEvent.endAuctionData);
			const diff = end.diff(now);

			if (diff <= 0) {
				setTimeLeft('Auction finished');
				clearInterval(timer);
				return;
			}

			const dur = dayjs.duration(diff);
			const hours = Math.floor(dur.asHours()).toString().padStart(2, '0');
			const minutes = dur.minutes().toString().padStart(2, '0');
			const seconds = dur.seconds().toString().padStart(2, '0');

			setTimeLeft(`${hours}:${minutes}:${seconds}`);
		}, 1000);

		return () => clearInterval(timer);
	}, [currentEvent?.endAuctionData]);

	const getUnBidedItems = async () => {
		if (!currentEvent) return;
		const {data} = await OrganizationAuctionService.getAuctionUnBidedItems(currentEvent?.id);
		setUnBidedItems(data);

		// setUnBidedItems(unBidedItems);
	};

	const notifyWinners = async () => {
		if (!currentEvent) return;

		try {
			await CommunicationService.notifyAuctionWinners(currentEvent.id);
			setIsNotifyModalOpen(false);
			toast.success('Notification sent successfully');
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	useEffect(() => {
		getUnBidedItems();
	}, [currentEvent?.id]);

	return (
		<>
			<Box sx={AuctionInfoStyles.wrapper}>
				<TableStatistics icon={JudgeIcon} title={unBidedItems} description={ITEM_WITHOUT_BIDS} onClick={() => {}} />
				<TableStatistics
					icon={TimeIcon}
					title={currentEvent?.isOnlineAuction ? timeLeft : 'Bidding at venue'}
					description={
						currentEvent?.isOnlineAuction
							? timeLeft === 'Auction finished'
								? ''
								: AUCTION_REMAINING
							: 'In-person event only'
					}
					onClick={() => {}}
				/>
				{isDesktop && auctionWonList && auctionWonList.data.length > 0 && (
					<TableStatistics
						icon={GuestIcon}
						title={NOTIFY_WINNERS}
						description=""
						onClick={handleNotifyModal}
						actionsData={['Notify']}
					/>
				)}
			</Box>
			<Modal
				onClose={handleNotifyModal}
				onSave={notifyWinners}
				open={isNotifyModalOpen}
				sx={WinnerTableStyle.modal}
				closeButtonTitle={CANCEL}
				mainButtonTitle={NOTIFY}
				isShowCloseButton
				isShowSaveButton
				mainIcon={<NotifyIcon />}
				title={NOTIFY_WINNERS}
				description="Are you sure you want to notify?"
			/>
		</>
	);
};

export default AuctionInfo;
